export default __webpack_public_path__ + "static/media/project11.2695b54c.PNG";